// Place search via Photon (komoot's free OSM geocoder). No API key needed.
// Used to set route start/end points by name instead of tapping the map.
export interface Place {
  label: string;
  coord: [number, number];
}

interface PhotonFeature {
  geometry: { coordinates: [number, number] };
  properties: {
    name?: string;
    street?: string;
    city?: string;
    state?: string;
    country?: string;
  };
}

// Bias biases results toward a [lng, lat] so nearby places rank first.
export async function searchPlaces(
  q: string,
  bias?: [number, number],
): Promise<Place[]> {
  if (q.trim().length < 3) return [];
  let url = `https://photon.komoot.io/api/?q=${encodeURIComponent(q)}&limit=5`;
  if (bias) url += `&lon=${bias[0]}&lat=${bias[1]}`;
  try {
    const res = await fetch(url);
    if (!res.ok) return [];
    const { features } = (await res.json()) as { features: PhotonFeature[] };
    return features.map((f) => {
      const p = f.properties;
      return {
        coord: f.geometry.coordinates,
        label: [p.name ?? p.street, p.city ?? p.state, p.country]
          .filter(Boolean)
          .join(", "),
      };
    });
  } catch {
    return [];
  }
}
